<h1 class="home-page-content-tab-label">Order Now For Collection</h1>

<div class="takeaway-tab-content" style="align-items: center" *ngIf="showNoSitesError">
  <p class="home-page-content-tab-error">There are no stores to show.</p>
</div>

<ng-container *ngIf="supportedSites.length > 0">
  <div class="takeaway-tab-shouldRedirect" *ngIf="noStoresFound">
    Sorry - we don't deliver to your postcode, please place a collection order instead
  </div>

  <div class="takeaway-tab-content flex-center flex-align-center" style="height: unset" *ngIf="supportedSites.length === 1; else storeCards">
    <button class="home-page-content-tab-button button-action-1" (click)="setSelectedStore(supportedSites[0])">
      <div class="home-page-content-tab-button-text"> ORDER NOW </div>
    </button>
  </div>

  <ng-template #storeCards>
    <div class="flex-row flex-wrap occasion-selector-stores">
      <div class="card flex-column" *ngFor="let store of supportedSites" (click)="setSelectedStore(store)">
        <span>{{ store.Name }}</span>
        <span *ngIf="store.Address">{{ store.Address.RoadNum + ' ' + store.Address.RoadName + ' ' + store.Address.Town  }}</span>
        <span *ngIf="store.Address?.Postcode">{{ store.Address.Postcode  }}</span>
        <a [href]="getPhoneNumber(store.Phone)" *ngIf="store.Phone">{{ store.Phone }}</a>
      </div>
    </div>
  </ng-template>
</ng-container>


